module.exports = {
  saved: 'Data has been saved',
  updated: 'Data has been updated',
  removed: 'Item has been removed',
  posted: 'Your post has been submitted',
  commented: 'Your comment has been submitted',
  discard: 'Action canceled',
  addCart: 'Item added to cart',
  checkout: 'Thank you for shopping',
  sent: 'Email sent',
  labeled: 'You just changed email label',
};
